import { useEffect, useMemo, useState } from "preact/hooks";
import { Config, httpGet } from "../services/api";

export enum FeatureFlags {
  checkout_theme = "checkout_theme",
}

type FeatureFlagResponse = {
  data: {
    enabled: boolean;
    name: string;
  };
};

export function useFeatureFlag(flagName: FeatureFlags) {
  const [isLoading, setIsLoading] = useState(true);
  const [isEnabled, setIsEnabled] = useState(false);

  const featureFlagUrl = useMemo(
    () =>
      new URL(
        `${import.meta.env.VITE_API_BASE}/api/${
          Config.apiVersion
        }/features/${flagName}/`
      ),
    [flagName]
  );

  useEffect(() => {
    httpGet<FeatureFlagResponse>(featureFlagUrl.toString(), true)
      .then((res) => {
        setIsEnabled(res.data.enabled);
      })
      .finally(() => setIsLoading(false));
  }, [featureFlagUrl]);

  return { isEnabled, isLoading };
}
